//
// Copyright (c) 2024 by Curalate, Inc.
//

/* global angular: false, _ */

(function () {
  angular.module('curalate').service('SchedulerService', [
    '$http',
    '$upload',
    'PromiseService',
    'RestBaseUrl',
    function ($http, $upload, PromiseService, RestBaseUrl) {
      this.addSavedImageUrlAsync = function (
        imageUrl,
        sourceUrl,
        description,
        productsList,
        universalItemId,
        videoId,
      ) {
        return this.addSavedImageUrlAsyncEx({
          imageUrl,
          sourceUrl,
          videoId,
          description,
          productsList,
          universalItemId,
        });
      };

      this.addSavedImageUrlAsyncEx = function (params) {
        return PromiseService.processHttpResponse(
          $http.post(`${RestBaseUrl}/publish/saved-images`, params),
        );
      };

      this.getProcessingVideos = function () {
        return PromiseService.processHttpResponse(
          $http.get(`${CURALATE_ENV.WEB_GATEWAY_URL}/api/v1/videos/processing`),
        ).then((data) => {
          return { savedImageIds: data.savedMediaIds };
        });
      };

      // In the post-square IG world, images can be non-square within bounds.
      // Tall images are limited to 4:5 width:height ratio, or 0.8
      //  (except IG stories are limited to 10:19 width:height ratio, or 0.52)
      // Wide images are limited to 19:10 width:height ratio, or 1.9
      this.instagramRatios = {
        WIDTH_HEIGHT_RATIO_LOWER_BOUND: 0.52,
        WIDTH_HEIGHT_RATIO_UPPER_BOUND: 1.9,
        WIDTH_HEIGHT_RATIO_LOWER_BOUND_STRING: '10:19',
        WIDTH_HEIGHT_RATIO_UPPER_BOUND_STRING: '19:10',
      };

      this.instagramVideoDuration = {
        DURATION_MINIMUM_IN_MS: 3 * 1000, // 3 seconds
      };

      this.getForceCropRatio = function (item, dimensions) {
        const isInstagram =
          item && item.buffer && item.buffer.network === 'Instagram';

        // Only force a crop for Instagram.
        // If not for IG or dimensions aren't known, no cropping.
        if (!isInstagram || !dimensions) {
          return null;
        }

        const widthHeightRatio =
          dimensions.naturalWidth / dimensions.naturalHeight;
        // Acceptable ratios for IG images in the post-square world are 0.8 to 1.9 W/H ratio.
        // If outside of these bounds, limit to the one that is surpassed.
        if (
          widthHeightRatio < this.instagramRatios.WIDTH_HEIGHT_RATIO_LOWER_BOUND
        ) {
          return this.instagramRatios.WIDTH_HEIGHT_RATIO_LOWER_BOUND_STRING;
        } else if (
          widthHeightRatio > this.instagramRatios.WIDTH_HEIGHT_RATIO_UPPER_BOUND
        ) {
          return this.instagramRatios.WIDTH_HEIGHT_RATIO_UPPER_BOUND_STRING;
        } else {
          // If we're in the goldilocks zone don't force any crops.
          return null;
        }
      };
    },
  ]);
})();
